export default __webpack_public_path__ + "static/media/japlong.3b572f7a.jpg";